import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import navigationService from '../services/router/navigationService';

// The 'replace: true' option prevents adding a new entry in the browser history,
// ensuring that the current page is replaced, and users can't navigate back to it.

const useNavigateReplace = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigationService.navigationRef.navigate = navigate;
    }, [navigate]);

    return (path, params = {}) => navigate(path, {replace: true, ...params});
};

export default useNavigateReplace;
